import React from 'react'
import useSWR from 'swr'
import { useParams } from 'react-router-dom'
import { ExpensesTable } from '../../components'
import { buildCacheKey } from '../../util'
import api from '../../api'
import { INewExpense } from '../../typings/entities/expense'
import { useExpensesQuery } from '../../hooks'

const ExpensesListPage: React.FC = () => {
	const [query] = useExpensesQuery()
	const params = useParams<{ entity: string }>()
	const cacheKey = buildCacheKey('expense', 'list', {
		query,
	})

	const { data } = useSWR<APIDataResponse<INewExpense>>(cacheKey, async () => {
		try {
			const response = await api.get('/expenses', {
				params: {
					...query,
					match: {
						...query.match,
						fundingEntities: params.entity,
					},
				},
			})

			return response.data.data
		} catch (error) {
			console.error(error)
		}
	})

	return <ExpensesTable data={data} />
}

export default ExpensesListPage
